export const experienceData = [
  {
    id: 1,
    company: "ITI",
    jobtitle: "9-Month Scholarship",
    startYear: "October 2022",
    endYear: "Present",
  },
  {
    id: 2,
    company: "MEGA TRUST TECH",
    jobtitle: "trainee flutter developer",
    startYear: "March 2022",
    endYear: "May 2022",
  },
];
